export default {
  methods: {
    generateKey () {
      return Math.random() * Math.random()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/helper.js